export const CHART_SEARCH_PARAM = 'chart';

function paramsFromSearch(search) {
  const raw = typeof search === 'string' ? search.replace(/^\?/, '') : '';
  return new URLSearchParams(raw);
}

export function readSearchParam(search, key) {
  return paramsFromSearch(search).get(key);
}

export function replaceSearchParam(search, key, value) {
  const params = paramsFromSearch(search);
  if (value == null || value === '') {
    params.delete(key);
  } else {
    params.set(key, value);
  }
  const next = params.toString();
  return next ? `?${next}` : '';
}
